var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "about-page" }, [
    _c("main", { staticClass: "about-main" }, [
      _c("div", { staticClass: "about-container" }, [
        _c("div", { staticClass: "about-logo" }, [
          _c("img", {
            staticClass: "about-logo-img",
            attrs: { src: _vm.logoImg, alt: "ChaCha" },
          }),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "about-section" }, [
      _c("h2", [_vm._v("About ChaCha:")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "ChaCha is a free voice chat application! Whether you're creating chat rooms or chatting with friends in voice groups, everything is free. Sounds exciting? Let's find out!"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "about-section" }, [
      _c("h2", [_vm._v("Main Functions:")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Live chat with friends either local  directly in a chat room."
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Free text message, high quality voice and video chat with your friends."
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "It offers a wide variety of virtual gifts, which you can send to your friends."
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "The more people watching, the more fantastic the atmosphere will be. Join a group room, start an online party with friends, make new friends, and have fun by expanding your social circle."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "about-section" }, [
      _c("p", [
        _vm._v(
          "Your happiness is our goal. Feel free to give us any feedback. We are happy to hear your complaints and advice: "
        ),
        _c("a", { attrs: { href: "mailto:contact@chachaapp.net" } }, [
          _vm._v("contact@chachaapp.net"),
        ]),
        _vm._v("."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }